import { createTheme } from "@mui/material/styles";

// Minimal professional palette: midnight indigo background, off-white text,
// a single electric-cyan accent. No gradients, no neon overload, no clutter.
const bg = "#0a0f1f"; /* midnight indigo */
const bgSecondary = "#161f3d"; /* noticeably lighter panel */
const textPrimary = "#dae2fd"; /* soft off-white */
const textMuted = "#9aa4c0"; /* muted for secondary text */
const accent = "#4cd7f6"; /* single accent - electric cyan */
const border = "rgba(76, 215, 246, 0.14)";
const monoFont =
  "ui-monospace, 'Cascadia Mono', 'Segoe UI Mono', 'Courier New', monospace";

let theme = createTheme({
  // ...
});
theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: accent,
    },
    secondary: {
      main: textMuted,
    },
    background: {
      default: bg,
      paper: "#1c2646",
      first: bg,
      secondary: bgSecondary,
    },
    text: {
      primary: textPrimary,
      secondary: textMuted,
    },
  },
  typography: {
    fontFamily:
      "'Segoe UI', system-ui, -apple-system, BlinkMacSystemFont, Roboto, Arial, sans-serif",

    tag: {
      fontFamily: monoFont,
      color: accent,
      letterSpacing: "1.5px",
      textDecoration: "none",
      textTransform: "uppercase",
      fontWeight: 500,
      fontSize: "13px",
      [theme.breakpoints.down("md")]: {
        fontSize: "12px",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "11px",
      },
    },
    menuText: {
      color: textPrimary,
      textDecoration: "none",
      fontSize: "15px",
      fontWeight: 500,
      textAlign: "center",
      [theme.breakpoints.down("md")]: {
        fontSize: "15px",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
      },
    },
    bigTitle: {
      color: textPrimary,
      letterSpacing: "-0.5px",
      textDecoration: "none",
      fontWeight: 700,
      fontSize: "40px",
      [theme.breakpoints.down("md")]: {
        fontSize: "30px",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "26px",
      },
    },

    subTitle: {
      color: textPrimary,
      letterSpacing: "0px",
      textDecoration: "none",
      fontWeight: 500,
      fontSize: "24px",
      [theme.breakpoints.down("md")]: {
        fontSize: "20px",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "17px",
      },
    },
    subSubTitle: {
      color: textMuted,
      letterSpacing: "0px",
      textDecoration: "none",
      fontWeight: 400,
      fontSize: "18px",
      lineHeight: "1.5",
      [theme.breakpoints.down("md")]: {
        fontSize: "17px",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "15px",
      },
    },

    coloredPra: {
      color: accent,
      fontWeight: 700,
    },
    normalTxt: {
      color: textPrimary,
      letterSpacing: "0px",
      lineHeight: "1.7",

      textDecoration: "none",
      fontSize: "16px",
      [theme.breakpoints.down("md")]: {
        fontSize: "15px",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "14.5px",
      },
    },

    smallTxt: {
      fontFamily: monoFont,
      color: textMuted,
      letterSpacing: "0px",

      textDecoration: "none",
      fontSize: "13px",
      lineHeight: "1.6",
      [theme.breakpoints.down("md")]: {
        fontSize: "13px",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "13px",
      },
    },
  },

  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: "#1c2646",
          color: textPrimary,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "8px",
          fontWeight: 600,
        },
      },
      variants: [
        {
          props: { variant: "fullBtn" },
          style: {
            backgroundColor: accent,
            color: bg,
            fontWeight: 600,
            padding: "10px 20px",
            border: `1px solid ${accent}`,
            transition: "opacity 0.2s ease, transform 0.2s ease",

            "&:hover": {
              backgroundColor: accent,
              opacity: 0.85,
              color: bg,
            },
            "& .MuiTypography-root": {
              color: "inherit",
            },
          },
        },
        {
          props: { variant: "outlineBtn" },
          style: {
            backgroundColor: "transparent",
            color: textPrimary,
            fontWeight: 600,
            padding: "10px 20px",
            border: `1px solid ${border}`,

            "&:hover": {
              borderColor: accent,
              backgroundColor: "rgba(79, 140, 255, 0.08)",
            },
            "& .MuiTypography-root": {
              color: "inherit",
            },
          },
        },
      ],
    },
  },
});

export default theme;
